import { Pilot } from '@/types/utm/pilot.types';

import { UTM_URL, utmApi } from './utm.api';

export const pilotApi = utmApi.injectEndpoints({
  endpoints: (builder) => ({
    createPilot: builder.mutation<Pilot, Partial<Pilot>>({
      query: (pilot: Pilot) => ({
        url: `${UTM_URL}/pilots`,
        method: 'POST',
        body: pilot,
      }),
    }),
    updatePilot: builder.mutation<Pilot, Pilot>({
      query: (pilot) => ({
        url: `${UTM_URL}/pilots/${pilot.id}`,
        method: 'PUT',
        body: pilot,
      }),
    }),
    deletePilot: builder.mutation<void, number>({
      query: (id) => ({
        url: `${UTM_URL}/pilots/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const { useCreatePilotMutation, useUpdatePilotMutation, useDeletePilotMutation } = pilotApi;
